import axiosInstance from 'api/axiosInstance'

export const putChatSettings = async (
    setup: Record<string, boolean | string>
) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/user/chat-settings',
        data: setup
    })
    return data
}

export const setWelcomeMessage = async (setup: any) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/chat/set-welcome-message',
        data: setup
    })

    return data
}

export const updateWelcomeMessage = async (setup: any) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/chat/update-welcome-message',
        data: setup
    })

    return data
}

export const getWelcomeMessage = async () => {
    const { data } = await axiosInstance.get(
        '/api/chat/welcome-message'
    )

    return data
}

export const putRemoveDuplicates = async (
    setup: { remove_duplicates: boolean }
) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/chat/remove-duplicates',
        data: setup
    })

    return data
}

export const deleteWelcomeMessage = async () => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: '/api/chat/delete-welcome-message'
    })

    return data
}